import { useMemo, type ReactNode } from 'react';
import type { LiveLlmCall } from '@localagent/sdk';
import { LiveLlmCallsContext } from './live-llm-calls';

export function LiveLlmCallsProvider({ calls, children }: { calls: LiveLlmCall[]; children: ReactNode }) {
  const byId = useMemo(() => new Map(calls.map((call) => [call.callId, call])), [calls]);
  return <LiveLlmCallsContext.Provider value={byId}>{children}</LiveLlmCallsContext.Provider>;
}
